import * as React from "react";
import { AssetContainer } from "./styles";

interface EmbeddedAssetFile {
  contentType: string;
  fileName: string;
  url: string;
  details: {
    size: number;
    image?: {
      width: number;
      height: number;
    };
  };
}

interface Props {
  file: EmbeddedAssetFile;
  id: string;
}

const EmbeddedAsset = ({ id, file }: Props) => {
  if (file.contentType.includes("image")) {
    return (
      <AssetContainer>
        <img src={file.url} alt={file.fileName} id={id} />
      </AssetContainer>
    );
  }
  if (file.contentType.includes("video")) {
    return (
      <AssetContainer>
        <video controls>
          <source src={file.url} type="video/mp4" />
        </video>
      </AssetContainer>
    );
  }

  return null;
};

export default EmbeddedAsset;
